export const lockKeys = {
  current: (documentSuperId: string | undefined, sectionSuperId: string | undefined) => ['documentLock', documentSuperId, sectionSuperId],
};
